const initialState = {}

export default function (state = initialState) {
  return state
}
